export const REACTION_GROUP_BY = {
	CATEGORY: 'category',
	INSTRUCTOR: 'instructor'
};
export const GROUP_BY_OPTIONS = [
	{ value: REACTION_GROUP_BY.CATEGORY, label: 'Category' },
	{ value: REACTION_GROUP_BY.INSTRUCTOR, label: 'Instructor' }
];
